import Head from '@otovo/shared/components/Head/Head';
import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { useElementHeightById } from '@otovo/shared/hooks/useElementHeightById';
import Script from 'next/script';
import { FormattedMessage as T, useIntl } from 'react-intl';
import m from './messages';
import RainbowLink from '@otovo/shared/components/RainbowLink/RainbowLink';
import { useRouter } from 'next/router';
import React from 'react';
import LinkButton from '@otovo/shared/rainbow/LinkButton/LinkButton';

const SupportPage = () => {
  const intl = useIntl();
  const config = useGlobalConfig();
  const { locale } = useRouter();
  const navbarHeight = useElementHeightById('otovoNavBar');
  const otovoFooter = useElementHeightById('otovoFooter');
  const height = `calc(100vh - ${navbarHeight}px - ${otovoFooter}px)`;

  return (
    <>
      <Script type="text/javascript" src="//js.hsforms.net/forms/v2.js" />
      <Head title={intl.formatMessage(m.headTitle)} />
      <div className="bg-lilac-5">
        <div
          className="mx-auto flex h-auto min-h-min max-w-7xl flex-col items-start px-8 py-12 md:justify-center"
          style={{ height }}
        >
          <h1 className="text-4xl font-semibold">
            <T {...m.pageTitle} />
          </h1>
          <div className="just flex flex-col md:flex-row md:items-center">
            <div className="my-4 flex flex-col text-muted">
              <p>
                <T {...m.pageDescriptionLine1} />
              </p>
              <p>
                <T {...m.pageDescriptionLine2} />
              </p>
            </div>
            <LinkButton
              href={config.HUBSPOT_KNOWLEDGE_BASE_URL}
              className="w-full items-center rounded-md px-5 py-3 md:ml-10 md:w-fit"
              variant="blue"
              target="_blank"
              rel="noreferrer nofollow"
            >
              <T {...m.wordFaq} />
            </LinkButton>
          </div>
          <div className="flex flex-col md:flex-row">
            <div className="mr-0 mt-14 flex flex-1 flex-col rounded-xl bg-white shadow md:mr-14">
              <div className="mt-4 p-6">
                <h3 className="font-semibold">
                  <T {...m.supportForCustomer} />
                </h3>
              </div>
              <div className="flex-grow px-6">
                <p className="text-muted">
                  <T {...m.customerCardDetail} />
                </p>
              </div>
              <div className="mt-8 bg-grey-1 p-6">
                <RainbowLink href={`${config.MYPAGE_URL}`} target="blank">
                  <T {...m.loginToGetHelp} />
                </RainbowLink>
              </div>
            </div>
            <div className="mt-14 flex flex-1 flex-col rounded-xl bg-white shadow">
              <div className="mt-4 p-6">
                <h3 className="font-semibold">
                  <T {...m.supportForNonCustomer} />
                </h3>
              </div>
              <div className="flex-grow px-6">
                <p className="text-muted">
                  <T
                    {...m.nonCustomerCardDetail}
                    values={{
                      localeLink: (
                        <RainbowLink
                          href={`${config.STOREFRONT_URL}/${locale}/`}
                        >
                          otovo.{config.BU_CONFIG.domain}
                        </RainbowLink>
                      ),
                      faqLink: config.HUBSPOT_KNOWLEDGE_BASE_URL ? (
                        <RainbowLink
                          href={config.HUBSPOT_KNOWLEDGE_BASE_URL}
                          target="_blank"
                          rel="noreferrer nofollow"
                        >
                          <T {...m.wordFaq} />
                        </RainbowLink>
                      ) : null,
                    }}
                  />
                </p>
              </div>
              <div className="mt-8 bg-grey-1 p-6">
                <RainbowLink href={config.STOREFRONT_URL} target="blank">
                  <T {...m.leaveAddressAndContactDetailsHelp} />
                </RainbowLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SupportPage;
